import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'highlight',
    standalone: true,
})
export class HighlightPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {}

    transform(text: string, searchTerm: string): SafeHtml {
        if (!searchTerm || !text) {
            return text;
        }

        const regex = new RegExp(`(${searchTerm})`, 'gi');
        const highlighted = text.replace(
            regex,
            '<span style="font-weight: bold; border-radius: 3px; color: #5000DB">$1</span>'
        );

        return this.sanitizer.bypassSecurityTrustHtml(highlighted);
    }
}
